const INDEX_DATA = [
  { title: '明星八卦全记录', desc: '热门明星动态追踪合集，涵盖恋情、婚姻、家庭等全方位八卦资讯。', count: '156篇', icon: 'ri-star-line' },
  { title: '综艺节目大揭秘', desc: '各大综艺节目幕后花絮、嘉宾关系、淘汰内幕独家揭秘。', count: '89篇', icon: 'ri-tv-line' },
  { title: '影视作品深度评', desc: '热门电影电视剧的深度评价、票房分析和收视率解读。', count: '203篇', icon: 'ri-film-line' },
  { title: '音乐圈风云录', desc: '歌手动态、新歌发布、演唱会资讯和音乐产业最新动态。', count: '134篇', icon: 'ri-music-line' },
  { title: '时尚潮流前线', desc: '红毯造型点评、明星私服穿搭、品牌代言最新资讯速递。', count: '98篇', icon: 'ri-t-shirt-line' },
  { title: '商业代言观察', desc: '品牌代言人更换、商业合作内幕和娱乐营销案例解析。', count: '76篇', icon: 'ri-building-line' },
  { title: '年度娱乐盘点', desc: '年度十大娱乐事件、最受欢迎明星和热门作品年终总结。', count: '45篇', icon: 'ri-calendar-check-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            <i className="ri-bookmark-line text-accent-500 mr-2"></i>主题索引
          </h2>
          <p className="mt-2 text-sm text-foreground-500">分类浏览，快速找到你感兴趣的吃瓜专题</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {INDEX_DATA.slice(0, 4).map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/60 rounded-xl p-5 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${
                  idx % 3 === 0 ? 'bg-primary-100' : idx % 3 === 1 ? 'bg-accent-100' : 'bg-secondary-100'
                }`}>
                  <i className={`${item.icon} text-lg ${
                    idx % 3 === 0 ? 'text-primary-500' : idx % 3 === 1 ? 'text-accent-500' : 'text-secondary-500'
                  }`}></i>
                </div>
                <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                {item.desc}
              </p>
              <span className="inline-block text-[10px] text-foreground-400 bg-background-200/60 px-2 py-1 rounded whitespace-nowrap">
                {item.count}
              </span>
            </div>
          ))}

          {INDEX_DATA.slice(4).map((item, idx) => (
            <div
              key={idx + 4}
              className="bg-background-50 border border-background-200/60 rounded-xl p-5 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${
                  (idx + 4) % 3 === 0 ? 'bg-primary-100' : (idx + 4) % 3 === 1 ? 'bg-accent-100' : 'bg-secondary-100'
                }`}>
                  <i className={`${item.icon} text-lg ${
                    (idx + 4) % 3 === 0 ? 'text-primary-500' : (idx + 4) % 3 === 1 ? 'text-accent-500' : 'text-secondary-500'
                  }`}></i>
                </div>
                <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                {item.desc}
              </p>
              <span className="inline-block text-[10px] text-foreground-400 bg-background-200/60 px-2 py-1 rounded whitespace-nowrap">
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}